import _taggedTemplateLiteral from "/home/cooper/dev/qikan/dingkan_admin/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  query($memberId: Int!) {\n    findMember(\n      memberId: $memberId,\n    ) {\n      id\n      nickname\n      profilePhoto\n      uniqueId\n      addresses {\n        id\n        className\n        year\n        realname\n        phone\n        isDefault\n        school {\n          id\n          name\n          area {\n            id\n            mergerName\n          }\n        }\n      }\n      createdAt\n      updatedAt\n    }\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import gql from 'graphql-tag';
export var findMember = gql(_templateObject());